import React, { useEffect, useState } from "react";
import { toast } from "../components/ui/sonner";
import { useApp } from "../context/AppContext";
import { Loader2, MessageSquareReply, CheckCircle2 } from "lucide-react";

/* 铃铛内联「回复催办原因」：PM 在铃铛里直接写原因 → 回到催办人的铃铛 + 分公司周报页 */
export const NudgeReplyInline = ({ reminder, compact = false, onChanged }) => {
  const { api, lang, user } = useApp();
  const zh = lang === "zh";
  const nid = reminder.nudgeId;
  const [n, setN] = useState(null);
  const [text, setText] = useState("");
  const [promise, setPromise] = useState("");
  const [busy, setBusy] = useState(false);
  const today = new Date().toISOString().slice(0, 10);
  useEffect(() => { if (nid) api.get(`/hrms/branch-digest/nudge/${nid}`).then((r) => setN(r.data)).catch(() => setN({ missing: true })); }, [api, nid]);
  if (!nid || !n || n.missing) return null;
  const mine = n.toUser === user.username || ["admin", "ceo", "eng_manager"].includes(user.role);
  if (n.reply) {
    return (
      <p className={`${compact ? "text-[10px]" : "text-[11px]"} text-emerald-700 flex items-start gap-1`} data-testid={`nudge-replied-${nid}`}>
        <CheckCircle2 className="h-3 w-3 mt-0.5 shrink-0" />{zh ? "已回复：" : "Replied: "}{n.reply}
        {n.promiseDate && <span className="ml-1 text-slate-500 whitespace-nowrap" data-testid={`nudge-promise-${nid}`}>· {zh ? "承诺" : "by"} {n.promiseDate}</span>}
      </p>
    );
  }
  if (!mine) return null;
  const send = async (e) => {
    e?.stopPropagation?.();
    if (!text.trim()) return toast.error(zh ? "请填写原因" : "Enter a reason");
    setBusy(true);
    try {
      const { data } = await api.post(`/hrms/branch-digest/nudge/${nid}/reply`, { text: text.trim(), promiseDate: promise || undefined });
      setN({ ...n, reply: data.reply, promiseDate: data.promiseDate });
      toast.success(zh ? "已回复催办人" : "Reply sent");
      onChanged?.();
    } catch (err) { toast.error(err?.response?.data?.detail || (zh ? "回复失败" : "Failed")); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={`nudge-reply-${nid}`} onClick={(e) => e.stopPropagation()}>
      {n.escalatedAt && <span className="w-full text-[10px] font-semibold text-red-600" data-testid={`nudge-escalated-${nid}`}>{zh ? "⚠ 48h 未回应，已二次催办并抄送工程经理" : "⚠ Unanswered 48h — escalated to eng. managers"}</span>}
      <input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send(e)} data-testid={`nudge-reply-input-${nid}`}
        placeholder={zh ? "回复延误原因 / 当前进度…" : "Reply with reason / progress…"}
        className={`flex-1 min-w-[140px] rounded-md border border-slate-200 bg-white px-2 ${compact ? "h-7 text-[11px]" : "h-8 text-xs"} focus:outline-none focus:ring-1 focus:ring-brand-300`} />
      <input type="date" value={promise} min={today} onChange={(e) => setPromise(e.target.value)} data-testid={`nudge-reply-promise-${nid}`}
        title={zh ? "预计恢复 / 完成日期（可选，到期未推进会自动再提醒）" : "Expected resume / finish date (optional)"}
        className={`rounded-md border border-slate-200 bg-white px-1.5 text-slate-600 ${compact ? "h-7 text-[10px] w-[118px]" : "h-8 text-xs w-[132px]"} focus:outline-none focus:ring-1 focus:ring-brand-300`} />
      <button type="button" onClick={send} disabled={busy} data-testid={`nudge-reply-send-${nid}`}
        className={`inline-flex items-center gap-1 rounded-full bg-brand-500 hover:bg-brand-600 text-white font-semibold px-2.5 ${compact ? "h-7 text-[10px]" : "h-8 text-xs"} disabled:opacity-50`}>
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <MessageSquareReply className="h-3 w-3" />}{zh ? "回复" : "Reply"}
      </button>
    </div>
  );
};
